module.exports = require("btoa");


//////////////////
// WEBPACK FOOTER
// external "btoa"
// module id = 6
// module chunks = 0